import { render, staticRenderFns } from "./happyfox_ticket_details_dialog.vue?vue&type=template&id=32924cd5&"
import script from "./happyfox_ticket_details_dialog.vue?vue&type=script&lang=js&"
export * from "./happyfox_ticket_details_dialog.vue?vue&type=script&lang=js&"
import style0 from "./happyfox_ticket_details_dialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports